module.exports = __webpack_public_path__ + "assets/img/Nexon-5-Landing-Page-w960.be13ff5c.webp";